module.exports = __webpack_public_path__ + "assets/img/logo_brand_text.40161ca2.svg";